import { render, staticRenderFns } from "./StatusPill.vue?vue&type=template&id=77fd48b6&scoped=true&"
import script from "./StatusPill.vue?vue&type=script&lang=js&"
export * from "./StatusPill.vue?vue&type=script&lang=js&"
import style0 from "./StatusPill.vue?vue&type=style&index=0&id=77fd48b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fd48b6",
  null
  
)

export default component.exports